/**
 * Shared Cyber Tracer chrome for Admin Console — matches Home / landing dark shell.
 */
export const ADMIN_FONT =
  "font-['Plus_Jakarta_Sans',Inter,ui-sans-serif,system-ui,sans-serif]";

export const ADMIN_SHELL =
  `admin-console min-h-screen bg-[#0f172a] ${ADMIN_FONT} text-sm text-slate-100`;

export const ADMIN_CARD =
  'rounded-2xl border border-white/10 bg-slate-900/55 p-4 shadow-lg shadow-black/30 backdrop-blur-md';

export const ADMIN_CARD_MUTED =
  'rounded-xl border border-white/10 bg-slate-950/55 p-3';

export const ADMIN_SECTION_TITLE =
  'mb-3 text-xs font-black uppercase tracking-[0.18em] text-slate-400';

export const ADMIN_BTN_PRIMARY =
  'rounded-xl bg-cyan-500 px-3 py-2 text-xs font-black uppercase tracking-wider text-slate-950 shadow-md shadow-cyan-500/20 transition hover:bg-cyan-400 disabled:cursor-not-allowed disabled:opacity-40';

export const ADMIN_BTN_GHOST =
  'rounded-xl border border-white/15 bg-slate-950/40 px-3 py-2 text-xs font-black uppercase tracking-wider text-slate-200 transition hover:border-cyan-500/40 hover:text-cyan-100 disabled:cursor-not-allowed disabled:opacity-40';

export const ADMIN_TAB_TRIGGER =
  'rounded-lg px-4 py-2 text-xs font-black uppercase tracking-wider text-slate-400 outline-none transition hover:bg-white/5 hover:text-slate-200 data-[state=active]:bg-cyan-500/20 data-[state=active]:text-cyan-100 data-[state=active]:ring-1 data-[state=active]:ring-cyan-400/40';

export const ADMIN_INPUT =
  'mt-1 w-full rounded-lg border border-white/15 bg-slate-950/70 px-3 py-2 font-mono text-xs text-slate-100 shadow-inner outline-none ring-cyan-500/30 placeholder:text-slate-500 focus:ring-2';

export const ADMIN_SELECT = ADMIN_INPUT;

export const ADMIN_CHART_COLORS = { cpu: '#22d3ee', ram: '#34d399', disk: '#a78bfa' };
